import { render, staticRenderFns } from "./DenyApplication.vue?vue&type=template&id=5b63e25a&scoped=true&"
import script from "./DenyApplication.vue?vue&type=script&lang=js&"
export * from "./DenyApplication.vue?vue&type=script&lang=js&"
import style0 from "./DenyApplication.vue?vue&type=style&index=0&id=5b63e25a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63e25a",
  null
  
)

export default component.exports